import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";

const colors = {
  sentiment: {
    positive: "#78D0EF",   // Positive color
    neutral: "#BDBCC8",    // Neutral color
    negative: "#F59694"    // Negative color
  },
  text: {
    dark: "#065f46",
    medium: "#10b981"
  },
  accent: "#e5e7eb",
};

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const positive = payload.find(p => p.dataKey === "positive")?.value || 0;
    const neutral = payload.find(p => p.dataKey === "neutral")?.value || 0;
    const negative = payload.find(p => p.dataKey === "negative")?.value || 0;
    return (
      <div
        style={{
          backgroundColor: "white",
          padding: "0.5rem",
          border: "1px solid #e5e7eb",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          borderRadius: "4px",
        }}
      >
        <p style={{ margin: 0, fontWeight: 500, color: "#374151" }}>{label}</p>
        <p style={{ margin: 0, fontSize: "0.75rem", color: "#4B5563" }}>
          {`Positive: ${positive}`}
        </p>
        <p style={{ margin: 0, fontSize: "0.75rem", color: "#4B5563" }}>
          {`Neutral: ${neutral}`}
        </p>
        <p style={{ margin: 0, fontSize: "0.75rem", color: "#4B5563" }}>
          {`Negative: ${negative}`}
        </p>
        <p
          style={{
            margin: 0,
            fontSize: "0.75rem",
            fontWeight: 500,
            marginTop: "0.5rem",
            paddingTop: "0.5rem",
            borderTop: "1px solid #e5e7eb",
            color: "#4B5563",
          }}
        >
          {`Total: ${positive + neutral + negative}`}
        </p>
      </div>
    );
  }
  return null;
};

const formatXAxisTick = (value) => value;

const SmallMultipleSentimentChart = ({ label, data, showPositive, showNeutral, showNegative, maxYAxis }) => {
  return (
    <div
      style={{
        maxWidth: 150,
        width: "100%",
        border: "1px solid #e5e7eb",
        padding: "5px",
        borderRadius: "8px",
        background: "#fff",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "2px" }}>
        <h3
          style={{
            color: colors.text.dark,
            borderBottom: `1px solid ${colors.accent}`,
            paddingBottom: "0.15rem",
            margin: 0,
            fontSize: "14px",
          }}
        >
          {label}
        </h3>
      </div>
      <ResponsiveContainer width="100%" height={140}>
        <BarChart data={data} margin={{ top: 5, right: 5, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.2} stroke={colors.accent} />
          <XAxis
            dataKey="sentiment"
            tick={{ fontSize: 10, fill: colors.text.medium }}
            tickFormatter={formatXAxisTick}
            height={30}
            axisLine={{ stroke: colors.accent }}
          />
          <YAxis
            tick={{ fontSize: 10, fill: colors.text.medium }}
            tickLine={false}
            axisLine={false}
            domain={[0, maxYAxis]}  // Set fixed max value
          />
          <Tooltip content={<CustomTooltip />} />
          {showPositive && (
            <Bar
              dataKey="positive"
              stackId="a"
              fill={colors.sentiment.positive}
              name="Positive"
              radius={[4, 4, 0, 0]}
              barSize={20}
            />
          )}
          {showNeutral && (
            <Bar
              dataKey="neutral"
              stackId="a"
              fill={colors.sentiment.neutral}
              name="Neutral"
              radius={[4, 4, 0, 0]}
              barSize={20}
            />
          )}
          {showNegative && (
            <Bar
              dataKey="negative"
              stackId="a"
              fill={colors.sentiment.negative}
              name="Negative"
              radius={[4, 4, 0, 0]}
              barSize={20}
            />
          )}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SmallMultipleSentimentChart;
